import { dateFormatter } from '@/grid/value-formatters/dateFormatter';
import {
  SUBFAMILY_FILTER_VALUES,
  SUBFAMILY_LABELS,
} from '@/utils/subfamilyValues';

const subfamilyColumn = {
  field: 'breed.subFamily',
  headerName: 'Species',
  filter: 'agSetColumnFilter',
  filterParams: {
    values: SUBFAMILY_FILTER_VALUES,
    valueFormatter: (params: any) =>
      SUBFAMILY_LABELS[params.value] ?? params.value,
  },
  valueFormatter: (params: any) =>
    SUBFAMILY_LABELS[params.value] ?? params.value ?? '',
  width: 80,
};

export const columnDefs = [
  {
    field: 'name',
    headerName: 'Sire Name',
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    field: 'breed.code',
    headerName: 'Breed',
    filter: 'agTextColumnFilter',
    width: 70,
  },
  subfamilyColumn,
  {
    field: 'breedReg',
    headerName: 'Breed Registration',
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    field: 'registrationNumber',
    headerName: 'Registration #',
    filter: 'agTextColumnFilter',
    width: 80,
  },
  {
    field: 'regPrefix',
    headerName: 'Country Code',
    filter: 'agTextColumnFilter',
    width: 80,
  },
  {
    field: 'cane',
    headerName: 'Cane',
    filter: 'agTextColumnFilter',
    width: 100,
  },
  {
    field: 'birth',
    headerName: 'Birth Date',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
    width: 100,
  },
  {
    field: 'sire',
    headerName: 'Pedigree Name',
    filter: 'agTextColumnFilter',
    width: 150,
  },
  {
    field: 'heparin',
    headerName: 'Heparin',
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'createdOn',
    headerName: 'Created On',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
    width: 100,
  },
  {
    field: 'modifiedOn',
    headerName: 'Modified On',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
    width: 100,
  },
];
